<div class="container-fluid">
    <div class="row">
        <div class="col-lg-4 col-md-4 col-sm-12 cadastro">Cadastro de incentivos em lote</div>
    </div>
    <div class="form-box container-fluid">
        <div class="row">
            <div class="col-12 form-title pt-4">Incentivos</div>
            <div class="col-12 form-subtitle pb-4">Que deseja atribuir aos favorecidos
            </div>
            <div class="col-12">
                <div class="py-2 container-fluid">
                    <div class="row">
                        <div class="custom-col-20 border-beneficio" *ngFor="let item of cartoes; let i= index">
                            <div class="mx-2 mt-4 mb-5">
                                <div class="custom-input-container form-check-inline my-4 col-12 mx-auto">
                                    <input [(ngModel)]="item.ativo" [attr.id]="item.cedenteContratoId" class="checkbox mx-2" type="checkbox" />

                                    <label [attr.for]="item.cedenteContratoId" class="form-check-label font-weight-normal">{{item.descricaoProduto}}
                                        <img
                                            [src]="'./assets/icons/produtos/icon-produtos/'+
                                            item.produtoGuid +'.svg'"
                                            onerror="this.src='./assets/icons/produtos/icon-produtos/SemImagem.svg';"
                                            class="img-card mb-5"
                                            alt="{{item.descricaoProduto}}" />
                                    </label>
                                </div>
                                <div class="div-select-create
                                    custom-input-container">
                                    <select [(ngModel)]="item.cartaoPeriodoPadrao" [attr.id]="i" class="custom-input-outline">
                                        <option disabled value="">Selecione...</option>
                                        <option [value]="1">Mensal</option>
                                        <option [value]="2">Diário</option>
                                    </select>
                                    <label class="custom-label-outline
                                        font-weight-normal" [attr.for]="i">Regularidade:</label>
                                </div>
                                <div class="custom-input-container">
                                    <span>R$ </span><input [(ngModel)]="item.valorPadrao" class="custom-input-outline" type="number" min="1" />
                                </div>
                                <div class="text-center text-danger" *ngIf="erroValor && (item.ativo &&
                                    item.valorPadrao <= 0)">
                                    <p>Valor inválido.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row button-container mt-5 mb-3">
                        <div class="col-6 text-left">
                            <button type="button" class="custom-button-previous" (click)="previous()">
                                VOLTAR
                            </button>
                        </div>
                        <div class="col-6 text-right">
                            <button type="button" class="custom-button-full" (click)="onSubmit()">
                                CONCLUIR
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>